import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sk-space_mb sk-space_mb--4 sk-space_mb--5-xl ds-caption ds-caption--appearance_black ds-caption--size_lg ds-caption--size_2xl-xl ds-caption--appearance_uppercase ds-caption--appearance_lh_sm u-display u-display--hidden-xl" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("Information")), 1),
    _createElementVNode("div", {
      class: "t-content",
      innerHTML: $props.content
    }, null, 8, _hoisted_2)
  ], 64))
}